<template>
  <div>
    
      <b-row align-v="center">
        <b-col sm="9">
          <h3>Search for people and sign them in</h3>
        </b-col>
        <b-col sm="1">
          <router-link
            :to="{
              name: searchIconRoutePath,
              params: { supressFilter: true, action: 'addAttendance' },
            }"
          >
            <font-awesome-icon
           
              icon="search"
              size="lg"
              style="color:#a2a2a2; cursor:pointer "
            ></font-awesome-icon>
          </router-link>
        </b-col>
        <b-col sm="2">
            <b-button
            to="{name:'home'}"
            variant="success"
            class= "float-right"
            >Home</b-button>
        </b-col>
      </b-row>
    

  
    <router-view></router-view>
 
    <app-register-of-signed-in></app-register-of-signed-in>
  </div>
</template>

<script>
import RegisterOfSignedIn from "./RegisterOfSignedIn";
export default {
  components: {
    appRegisterOfSignedIn: RegisterOfSignedIn,
  },
  computed: {
    searchIconRoutePath() {
      if (this.$route.name == "people-search") {
        return "staff-operated-signin";
      }
      return "people-search";
    },
  },
};
</script>
<style scoped>
<style>
#fileInput {
  display: none;
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-leave {
  /*opacity: 1*/
}
.fade-leave-active {
  transition: opacity 1s;
  opacity: 0;
}
.slide-enter {
  opacity: 0;
}
.slide-enter-active {
  animation: slide-down 0.5s ease-out forwards;
  transition: opacity 0.5s;
}
.slide-leave {
}
.slide-leave-active {
  animation: slide-up 0.5s ease-out forwards;
  transition: opacity 0.5s;
  opacity: 0;
}
@keyframes slide-up {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-20px);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-20px);
  }
  to {
    transform: translateY(0px);
  }
}
</style>

